import { Api } from "./Api.class";
const endpoint = "media_objects";
const MediaObjectsAPI = new Api(endpoint);
export default MediaObjectsAPI;
